/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicKeyAuthenticator
 */
export interface PublicKeyAuthenticator {
    /**
     * Base64-encoded AAGUID of the authenticator device
     * @type {string}
     * @memberof PublicKeyAuthenticator
     */
    aaguid: string;
    /**
     * 
     * @type {number}
     * @memberof PublicKeyAuthenticator
     */
    sign_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PublicKeyAuthenticator
     */
    clone_warning?: boolean;
}

/**
 * Check if a given object implements the PublicKeyAuthenticator interface.
 */
export function instanceOfPublicKeyAuthenticator(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "aaguid" in value;

    return isInstance;
}

export function PublicKeyAuthenticatorFromJSON(json: any): PublicKeyAuthenticator {
    return PublicKeyAuthenticatorFromJSONTyped(json, false);
}

export function PublicKeyAuthenticatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicKeyAuthenticator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aaguid': json['aaguid'],
        'sign_count': !exists(json, 'sign_count') ? undefined : json['sign_count'],
        'clone_warning': !exists(json, 'clone_warning') ? undefined : json['clone_warning'],
    };
}

export function PublicKeyAuthenticatorToJSON(value?: PublicKeyAuthenticator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aaguid': value.aaguid,
        'sign_count': value.sign_count,
        'clone_warning': value.clone_warning,
    };
}

